<template>
  <kendo-window
      ref="loginMfaWindowRef"
      :title="'2차 인증'"
      :modal="true"
      :width="'450px'"
      :height="''"
      :auto-focus="false"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
      @close="onCloseWindow"
  >
    <div class="e-auth">
      <div class="e-auth_content">
        <div class="e-auth_title">2차 인증</div>

        <div class="e-auth_group">
          <label class="e-auth_label">이메일</label>
          <div class="e-auth_input-wrap">
            <input type="text" :placeholder="sendEmail" disabled/>
            <button
                type="button"
                class="e-mid-btn e-btn-fill-primary"
                :disabled="resending"
                @click="resend"
            >인증번호 재발송</button>
          </div>
          <div style="color:#666; margin-top: 6px;">
            로그인을 시도하면 인증번호가 자동으로 발송됩니다. 메일이 오지 않으면 재발송해 주세요.
          </div>
        </div>

        <div>
          <div class="e-auth_group">
            <div class="e-auth_label-wrap">
              <label for="loginMfaCode" class="e-auth_label">인증번호</label>
              <span ref="leftTimeRef" class="e-auth_timer"></span>
            </div>
          </div>
          <input
              id="loginMfaCode"
              ref="authNoRef"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength="6"
              class="e-auth_code-input"
              placeholder="000000"
              v-model.trim="authNo"
              @input="onlyNumber"
              @keyup.enter="verify"
              :disabled="expired"
          />
          <div v-if="expired" style="color:#E83C4F; margin-top: 6px;">
            인증 유효시간이 지났습니다. 인증번호를 재발송해 주세요.
          </div>
        </div>

        <button
            type="button"
            class="e-mid-btn e-btn-fill-primary"
            :disabled="authNo.length !== 6 || expired"
            @click="verify"
        >확인</button>
      </div>
    </div>
  </kendo-window>
</template>

<script>
export default {
  name: 'LoginMfa',
  props: {
    // 1차 로그인 응답의 resultData (mfaToken, sendEmail, expireSeconds)
    mfaData: {
      type: Object,
      required: true
    }
  },
  mounted () {
    const vm = this

    vm.$refs.loginMfaWindowRef.kendoWidget().center().open()
    vm.startLeftTime(vm.$props.mfaData.expireSeconds)

    vm.$nextTick(function () {
      vm.$refs.authNoRef?.focus()
    })
  },
  beforeDestroy () {
    // 화면을 떠난 뒤에도 타이머가 살아 있으면 없어진 DOM 을 계속 건드린다.
    this.clearLeftTime()
  },
  methods: {
    // 인증번호는 숫자만 받는다. 붙여넣기로 공백이나 하이픈이 섞여 들어오는 경우가 있다.
    onlyNumber () {
      this.authNo = (this.authNo || '').replace(/[^0-9]/g, '')
    },
    // 인증 유효시간 출력(1초 단위)
    startLeftTime (expireSeconds) {
      const vm = this

      vm.clearLeftTime()

      let count = expireSeconds > 0 ? expireSeconds : 0
      let display = vm.$refs.leftTimeRef

      vm.expired = false

      vm.leftTimer = setInterval(function () {
        let minutes = parseInt(count / 60, 10)
        let seconds = parseInt(count % 60, 10)
        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds

        display.textContent = minutes + ':' + seconds

        if (--count < 0) {
          vm.clearLeftTime()
          display.textContent = '시간초과'
          vm.expired = true
        }
      }, 1000)
    },
    clearLeftTime () {
      if (this.leftTimer) {
        clearInterval(this.leftTimer)
        this.leftTimer = null
      }
    },
    // 인증번호 확인
    verify () {
      const vm = this

      if (!vm.authNo || vm.authNo.length !== 6) {
        kendo.alert('인증번호 6자리를 입력해 주세요.').bind('close', function () {
          vm.$refs.authNoRef.focus()
        })
        return false
      }

      /*
       * 시간이 지난 뒤 눌러도 서버가 막아주지만, 굳이 보내서 틀린 것처럼 보이게 할 필요는 없다.
       * 화면 시계와 서버 시계가 어긋날 수 있으므로 판단은 서버에 맡기고 여기서는 안내만 한다.
       */
      if (vm.expired) {
        kendo.alert('인증 유효시간이 지났습니다.<br>인증번호를 재발송해 주세요.')
        return false
      }

      let params = {
        mfaToken: vm.$props.mfaData.mfaToken,
        authNo: vm.authNo,
      }

      vm.$store.dispatch('FETCH_VERIFY_LOGIN_MFA', params).then(verifyData => {

        if (verifyData === undefined || verifyData.resultStatus === undefined) {
          kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
          return false
        }

        if (verifyData.resultStatus.messageCode !== '2000') {
          /*
           * 인증번호를 5회 틀리거나 유효시간이 지나면 서버가 발급 건을 폐기한다.
           * 그 뒤로는 재발송도 되지 않으므로 로그인 화면으로 되돌려보낸다.
           */
          if (vm.isRestartRequired(verifyData.resultStatus.messageText)) {
            kendo.alert(verifyData.resultStatus.messageText).bind('close', function () {
              vm.closeAndCancel()
            })
            return false
          }

          kendo.alert(verifyData.resultStatus.messageText).bind('close', function () {
            vm.authNo = ''
            vm.$refs.authNoRef.focus()
          })
          return false
        }

        vm.clearLeftTime()
        // 창을 닫을 때 취소로 오인되지 않도록 표시해 둔다.
        vm.verified = true
        vm.$refs.loginMfaWindowRef.kendoWidget().close()

        // 여기서부터는 일반 로그인과 동일하다. 이후 처리는 Login 화면이 이어서 한다.
        vm.$emit('verified', verifyData.resultData)
      })
    },
    // 인증번호 재발송
    resend () {
      const vm = this

      vm.resending = true

      vm.$store.dispatch('FETCH_RESEND_LOGIN_MFA', { mfaToken: vm.$props.mfaData.mfaToken })
      .then(resendData => {

        vm.resending = false

        if (resendData === undefined || resendData.resultStatus === undefined) {
          kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
          return false
        }

        if (resendData.resultStatus.messageCode !== '2000') {
          kendo.alert(resendData.resultStatus.messageText).bind('close', function () {
            vm.closeAndCancel()
          })
          return false
        }

        /*
         * 재발송하면 서버가 새 번호를 만든다. 앞서 받은 번호는 더 이상 통하지 않으므로
         * 입력칸을 비우고 타이머도 새로 받은 유효시간으로 다시 시작한다.
         */
        vm.authNo = ''
        vm.startLeftTime(resendData.resultData.expireSeconds)

        kendo.alert('인증번호를 다시 보냈습니다.<br>이전에 받은 번호는 사용할 수 없습니다.')
        .bind('close', function () {
          vm.$refs.authNoRef.focus()
        })
      })
    },
    /*
     * 처음부터 다시 로그인해야 하는 상황인지 본다.
     * 서버가 메시지 코드를 따로 두지 않고 안내 문구로만 구분하므로 문구로 판단한다.
     */
    isRestartRequired (messageText) {
      return (messageText || '').indexOf('다시 로그인') > -1
    },
    closeAndCancel () {
      this.$refs.loginMfaWindowRef.kendoWidget().close()
    },
    /*
     * 창이 닫히면 2차 인증을 중단한 것으로 본다.
     * 인증에 성공해서 닫은 경우는 이미 verified 를 올려보냈으므로 여기서 아무것도 하지 않는다.
     */
    onCloseWindow () {
      this.clearLeftTime()

      if (!this.verified) {
        this.$emit('cancel')
      }
    },
  },
  data () {
    return {
      authNo: '',
      leftTimer: null,
      expired: false,
      resending: false,
      verified: false,
    }
  },
  computed: {
    sendEmail () {
      return this.$props.mfaData.sendEmail
    }
  },
}
</script>

<!--
  E-system(ebmp-design/public/E-system/e-system.css)의 인증창 스타일을 옮겨왔다.
  원본은 5,000줄이 넘고 --PrimaryColor 같은 디자인 시스템 변수를 전제로 해서,
  이 화면에 필요한 규칙만 값으로 풀어 담는다. 기존 style.css 와 섞이지 않도록 scoped 로 둔다.
-->
<style scoped>
.e-auth {
  padding: 20px;
  color: #000;
  font-family: 'Pretendard', sans-serif;
  border-radius: 8px;
}

.e-auth_content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.e-auth_title {
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  color: #000;
}

.e-auth_label {
  margin-bottom: 6px;
  display: block;
  font-size: 14px;
  color: #000;
}

.e-auth_input-wrap {
  display: flex;
  gap: 8px;
}

.e-auth_input-wrap input {
  flex: 1;
  background: #EFF2FF;
}

.e-auth_label-wrap {
  display: flex;
  justify-content: space-between;
}

.e-auth_timer {
  color: #E83C4F;
  font-size: 13px;
}

.e-auth_code-input {
  width: 100%;
  height: 44px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  border: 1px solid #D1D1D1;
  border-radius: 5px;
  letter-spacing: 12px;
  text-indent: 12px;
}

.e-auth_code-input:focus {
  border-color: #FF6E40;
  background: #FEF2F2;
}

.e-mid-btn {
  display: flex;
  height: 36px;
  min-width: 60px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border: none;
  border-radius: 5px;
  box-shadow: 0px 2px 3px 0px rgba(77, 77, 77, 0.10);
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
  cursor: pointer;
  transition: background 0.3s ease-in-out, box-shadow 0.3s;
}

.e-btn-fill-primary {
  background-color: #FF6E40;
  color: #FFF;
}

.e-btn-fill-primary:hover {
  background: #FE4011;
  box-shadow: 0px 4px 10px 0px rgba(112, 112, 112, 0.40);
}

.e-btn-fill-primary:disabled {
  color: #D1D1D1 !important;
  background: #E7E7E7 !important;
  border: none !important;
  cursor: default;
}
</style>
